/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { FormattedNumber } from 'react-intl';
// import { getCurrency } from '../../../../utils';
import {
  PowerContainerWrap,
  // PowerProgram,
  PowerContainer,
  PowerTitle,
  PowerValueContainer,
  HAIR_CARE,
  // SCALP_CARE,
  CardBackground,
  CardContent,
  CardContainer,
  CardBody,
  CardHeader,
  CardCloseButton,
} from '../Common/Common.style';
import {
  StepWrap,
  StepHeader,
  StepTitle,
  StepProgram,
  StepTitleWrap,
  StepPowerWrap,
  StepList,
  StepListItem,
} from './DiagnosisResultStepCard.style';
import Image from '../../../../components/ContentfulImage';
import Placeholder from '../../../../components/Placeholder';

class DiagnosisResultStepCard extends React.Component {
  state = {}; // for lint

  renderPower = (power, maxPower = 4) => {
    const indents = [];
    for (let i = 0; i < maxPower; i += 1) {
      if (i < power) {
        indents.push(<li key={i} className="active" />);
      } else {
        indents.push(<li key={i} />);
      }
    }
    return indents;
  };

  renderPrice = (price, authSalonSettingData, locale) => {
    if (
      price &&
      authSalonSettingData &&
      authSalonSettingData.basicSettings &&
      authSalonSettingData.basicSettings.currencyCode
    ) {
      const localeName = locale.split('_')[0];
      const currencyName = authSalonSettingData.basicSettings.currencyCode;
      return new Intl.NumberFormat(localeName, { style: 'currency', currency: currencyName }).format(price);
    }
    return null;
  };

  render() {
    const { isOpen, handleCloseCard, diagnosisResultType, careItem, authSalonSettingData, copy, locale } = this.props;
    return (
      <React.Fragment>
        <CardBackground onClick={handleCloseCard} className={isOpen ? 'active' : ''} />
        <CardContainer className={isOpen ? 'active' : ''}>
          <CardContent>
            <CardHeader onClick={handleCloseCard}>
              <CardCloseButton className="closeButton" />
            </CardHeader>
            <CardBody>
              <StepWrap>
                <StepHeader>
                  <StepTitleWrap>
                    <StepTitle>{(careItem && careItem.title) || <Placeholder w="240px" h="60px" />}</StepTitle>
                    <StepProgram>
                      {careItem &&
                        careItem.salonSetting && <div className="title">{careItem.salonSetting.displayName} :</div>}
                      {(careItem && (
                        <div className="caption">
                          <React.Fragment>
                            {careItem &&
                              careItem.salonSetting &&
                              careItem.salonSetting.operationTime &&
                              `${careItem.salonSetting.operationTime || 0} ${copy.common.minute || ''} `}
                            {careItem &&
                              careItem.salonSetting &&
                              careItem.salonSetting.price && (
                                <React.Fragment>
                                  {this.renderPrice(careItem.salonSetting.price, authSalonSettingData, locale)}
                                </React.Fragment>
                              )}
                          </React.Fragment>
                        </div>
                      )) || <Placeholder w="240px" h="25px" />}
                    </StepProgram>
                  </StepTitleWrap>
                  <StepPowerWrap>
                    <PowerContainerWrap>
                      {careItem &&
                        careItem.features &&
                        careItem.features.map((feature, index) => (
                          <PowerContainer key={index}>
                            {feature.name && <PowerTitle>{feature.name}</PowerTitle>}
                            {feature.value && (
                              <PowerValueContainer theme={diagnosisResultType}>
                                <ul className="powerbar">
                                  {this.renderPower(feature.value, 4)}
                                  {/* {this.renderPower(feature.value, diagnosisResultType === HAIR_CARE ? 4 : 3)} */}
                                </ul>
                              </PowerValueContainer>
                            )}
                          </PowerContainer>
                        ))}
                    </PowerContainerWrap>
                  </StepPowerWrap>
                </StepHeader>

                <StepList>
                  {careItem &&
                    careItem.steps &&
                    careItem.steps.steps &&
                    careItem.steps.steps.map((step, index) => (
                      <StepListItem key={index}>
                        <div className="step">{`STEP${index + 1}`}</div>
                        <div className="image">
                          {(!!step.sublimicResutlIcon && (
                            <Image
                              src={step.sublimicResutlIcon}
                              options={{ w: '76px', h: '100%', objectFit: 'contain' }}
                            />
                          )) || <Placeholder w="76px" h="76px" />}
                        </div>
                        <div className="text">
                          {step.sublimicResutlDescription || <Placeholder w="76px" h="20px" />}
                        </div>
                      </StepListItem>
                    ))}
                </StepList>
              </StepWrap>
            </CardBody>
          </CardContent>
        </CardContainer>
      </React.Fragment>
    );
  }
}

DiagnosisResultStepCard.defaultProps = {
  diagnosisResultType: HAIR_CARE,
  careItem: null,
  copy: {},
  salonSolutionData: null,
  authSalonSettingData: {},
};
DiagnosisResultStepCard.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleCloseCard: PropTypes.func.isRequired,
  diagnosisResultType: PropTypes.string,
  careItem: PropTypes.shape({}),
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  salonSolutionData: PropTypes.shape({}),
  authSalonSettingData: PropTypes.shape({}),
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  salonSolutionData: state.salonSolutionList,
  authSalonSettingData: state.authSalonSettings,
  locale: state.locale,
});

export default connect(mapState)(DiagnosisResultStepCard);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/DiagnosisResultStepCard/DiagnosisResultStepCard.js